import React from 'react';
import { motion } from 'framer-motion';
import { ScrollTextIcon } from 'lucide-react';
interface ButtonCTAProps {
  text?: string;
  className?: string;
  scrollToOffer?: boolean;
}
export function ButtonCTA({
  text = '¡QUIERO ESCRIBIR MI VISIÓN AHORA!',
  className = '',
  scrollToOffer = true
}: ButtonCTAProps) {
  const sharedProps = {
    whileHover: {
      scale: 1.03,
      boxShadow: '0 10px 25px -5px rgba(201, 168, 76, 0.4)'
    },
    whileTap: {
      scale: 0.98
    },
    className: `
      relative overflow-hidden group cursor-pointer
      bg-gradient-to-b from-gold-light to-gold-dark
      text-navy-dark font-serif font-bold text-lg md:text-xl
      py-4 px-8 rounded-sm shadow-lg
      flex items-center justify-center gap-3
      border border-gold-light/50
      transition-all duration-300
      w-full sm:w-auto
      no-underline
      ${className}
    `
  };
  const content = <>
      <div className="absolute inset-0 -translate-x-full group-hover:animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-12" data-id="element-14"></div>
      <ScrollTextIcon className="w-6 h-6" data-id="element-15" />
      <span className="relative z-10 tracking-wide" data-id="element-16">{text}</span>
    </>;
  if (scrollToOffer) {
    return <motion.button {...sharedProps} onClick={() => document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    })} data-id="element-17">
        {content}
      </motion.button>;
  }
  return <motion.a href="https://buenavibrax.com/cart/45647771828281:1" target="_blank" rel="noopener noreferrer" {...sharedProps} data-id="element-18">
      {content}
    </motion.a>;
}